<template>
  <div class="header-h2">
    <h1>{{ captionTab }}</h1>
  </div>
</template>

<script>
    export default {
        props: {
            captionTab: {
                type: String,
                default: true,
            },
        }
    }
</script>
